import React from "react";
import { Helmet } from "react-helmet-async";

import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import HeroSection from "../../components/HeroSection/Hero";

import OrderForm from "../../components/OrderForm/OrderForm";

import HeroImage from "../../assets/images/kiwi.png";

import "./orderHere.css";

function OrderHere() {
  return (
    <div>
      <Helmet>
        <title>Order Here</title>
      </Helmet>

      <Header />

      <HeroSection
        backgroundImage={HeroImage}
        title="We're Here to Help"
        subtitle="Order Here"
        dividerPath="M0,160L48,149.3C96,139,192,117,288,117.3C384,117,480,139,576,144C672,149,768,139,864,133.3C960,128,1056,128,1152,138.7C1248,149,1344,171,1392,181.3L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        dividerColour="var(--shading-colour)"
      />

      <div className="OrderInfoContainer">
        <div className="OrderInfo">
          <h2>Packaging</h2>
          <p>
          Order any number of 1-litre concentrate bottles. 
          A full carton holds up to 12—mix and match flavors to suit your needs.
          </p>
          <p className="price-note">
            <strong>All prices are exclusive of GST.</strong>
          </p>
          <br></br>
          <h2>Ordering Dispensing Machinery</h2>
          <p>
            Contact us for more information on our dispensing machinery options.
          </p>
        </div>
      </div>
      <br></br>
      <div className="OrderSection">
        <div className="OrderForm">
          <OrderForm />
        </div>
      </div>
      <br></br>
      <Footer />
    </div>
  );
}

export default OrderHere;
